import { render } from "./ToolBarHygiene.vue?vue&type=template&id=5d81ef10"
import script from "./ToolBarHygiene.vue?vue&type=script&lang=js"
export * from "./ToolBarHygiene.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__